import { ABANDONED_CART_ROUTES } from './AbandonedCart';
import { DRAFT_ORDERS_ROUTES } from './DraftOrders';
import { ORDERS_SECTION_ROUTES } from './Orders';

export const ORDERS_ROUTES = {
  ...DRAFT_ORDERS_ROUTES,
  ...ABANDONED_CART_ROUTES,
  ...ORDERS_SECTION_ROUTES,
};
